import VisitTypeCategoriesAccordion from './VisitTypeCategoriesAccordion'

export default VisitTypeCategoriesAccordion
